// eslint-disable-next-line import/prefer-default-export
export const ESTADO_FATURA = {
  PENDENTE: 1,
  PAGO: 2,
  PAGAMENTO_EM_ANALISE: 3,
  CANCELADO: 4,
  VENCIDO: 5,
  BAIXA: 6,
  PROCESSANDO: 7,
  FALHA: 8,
};
